import {createSvgIcon} from '../create-svg-icon';

export const DragHandleIcon = createSvgIcon(
  <path d="M20 9H4v2h16V9zM4 15h16v-2H4v2z" />
, 'DragHandleOutlined');
